interface EyebrowProps {
  text: string;
  blue?: boolean;
}

export default function Eyebrow({ text, blue = false }: EyebrowProps) {
  return <span className={`eyebrow ${blue ? "eyebrow-blue" : ""}`}>{text}</span>;
}
